"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _useDialog2 = _interopRequireDefault(require("../hooks/useDialog2"));

var _react = _interopRequireWildcard(require("react"));

var _QdLearningQuestionView = _interopRequireDefault(require("../views/QdLearningQuestionView"));

var _SeriesContextProvider = require("../context/SeriesContextProvider");

var _TypeToReactComponent = require("../helpers/TypeToReactComponent");

function _default(props) {
  var _useDialog = (0, _useDialog2["default"])(props),
      readySubDialogs = _useDialog.readySubDialogs;

  var _ref = (0, _SeriesContextProvider.useSeriesContext)(),
      setLastAnswerWasCorrect = _ref.setLastAnswerWasCorrect,
      lastAnswerWasCorrect = _ref.lastAnswerWasCorrect;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentSubDialogs = _useState2[0],
      setCurrentSubDialogs = _useState2[1];

  function onAnswer() {
    if (Math.random() >= 0.5) {
      setLastAnswerWasCorrect(true);
    } else {
      setLastAnswerWasCorrect(false);
    }

    props.goToNextDialog();
  }

  (0, _react.useEffect)(function () {
    var tempCurrentSubDialogs = [];
    readySubDialogs.forEach(function (dialog) {
      tempCurrentSubDialogs.push(dialog);
    });
    setCurrentSubDialogs(tempCurrentSubDialogs);
  }, [readySubDialogs]);
  return /*#__PURE__*/_react["default"].createElement(_QdLearningQuestionView["default"], null, currentSubDialogs.map(function (dialog) {
    return (0, _TypeToReactComponent.getComponent)(dialog, {
      onAnswer: onAnswer
    });
  }));
}